import { Box, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody } from '@chakra-ui/react';

import { modalDetailWarehouseText } from 'Const/stock-promo/view';
import { TextBold, TextMedium, TextRegular, TextSemiBold } from 'UiKit/typography';
import MemoizedTableComponent from 'UiKit/table-component';

import { useStockPromoState } from 'View/stock-promo/state';

import tableList from './const';

import styles from './styles.module.css';

const DetailWarehouseModal = () => {
  const { isOpenModalDetailWarehouse, detailWarehouseData, updateState } = useStockPromoState();

  const handleCloseModal = () => {
    updateState({ isOpenModalDetailWarehouse: false, detailWarehouseData: null });
  };

  const productStorages = detailWarehouseData?.productStorages;
  const isDataExist = productStorages && productStorages.length > 0;

  return (
    <Modal isOpen={isOpenModalDetailWarehouse} onClose={handleCloseModal} isCentered>
      <ModalOverlay />
      <ModalContent minWidth={'800px'}>
        <ModalHeader>
          <TextBold className={styles['modal__text--title']}>{modalDetailWarehouseText.title}</TextBold>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody className={styles['modal__section--content']}>
          <Box className={styles['modal__section--product']}>
            <TextSemiBold className={styles['modal__text--product-name']}>{detailWarehouseData?.name}</TextSemiBold>
            <Box className={styles['modal__row--product']}>
              <Box className={styles['modal__column--sku']}>
                <TextRegular className={styles['modal__text--label']}>{modalDetailWarehouseText.skuText}</TextRegular>
                <TextMedium className={styles['modal__text--value']}>{detailWarehouseData?.sku}</TextMedium>
              </Box>
              <Box className={styles['modal__column--brand']}>
                <TextRegular className={styles['modal__text--label']}>{modalDetailWarehouseText.brandText}</TextRegular>
                <TextMedium className={styles['modal__text--value']}>{detailWarehouseData?.brand}</TextMedium>
              </Box>
            </Box>
          </Box>
          <Box className={styles['modal__section--warehouse-list']}>
            <MemoizedTableComponent
              columns={tableList}
              containerClassName={styles['modal__table--container']}
              dataSource={productStorages}
              isDataExist={isDataExist}
              rowHeight="42px"
            />
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default DetailWarehouseModal;
